export default __webpack_public_path__ + "static/media/BrainBreak cards23.f4ac4f21.png";